import { createSelector } from 'reselect';

const getAppReducer = (state) => state.containers.app;
const getSessionReducer = (state) => state.session;
const getSectionReducer = (state, sectionID) =>
  state.containers.appSections.sectionStates.get(sectionID);
const getProfileReducer = (state) => state.containers.profileManager;
const getPlayerEpgSection = (state) => state.containers.playerEpgSection;
const getAppSectionsReducer = (state) => state.containers.appSections;

export const selectAccessToken = createSelector(
  getSessionReducer,
  (reducer) => reducer.accessToken,
);

export const selectIsFetching = createSelector(
  getSectionReducer,
  (reducer) => reducer.isFetching,
);

export const selectWidgetCollection = createSelector(
  getSectionReducer,
  (reducer) => reducer.widgetCollection,
);

export const selectSelectedContent = createSelector(
  getSectionReducer,
  (reducer) => reducer.selectedContent,
);

export const selectToggleModal = createSelector(
  getSectionReducer,
  (reducer) => reducer.toggleModal,
);

export const selectAppSettings = createSelector(
  getAppReducer,
  (reducer) => reducer.appSettings,
);

export const selectAuthenticated = createSelector(
  getSessionReducer,
  (reducer) => reducer.authenticated,
);

export const selectFavoritesContents = createSelector(
  getProfileReducer,
  (reducer) => reducer.favorites,
);

export const selectWidgetCollectionPaginate = createSelector(
  getSectionReducer,
  (reducer) => reducer.widgetCollectionPaginate ?? [],
);

export const selectPage = createSelector(
  getSectionReducer,
  (reducer) => reducer.page,
);

export const selectIsPlayerEpgSection = createSelector(
  getPlayerEpgSection,
  (reducer) => reducer.isPlayerEpgSection,
);

export const selectSectionError = createSelector(
  getSectionReducer,
  (reducer) => reducer.error ?? {},
);

export const selectPathList = createSelector(
  getAppSectionsReducer,
  (reducer) => reducer.pathList,
);

export const selectSectionCollection = createSelector(
  getAppSectionsReducer,
  (reducer) => reducer.sectionCollection,
);
